/* eslint-disable @typescript-eslint/no-explicit-any */
import { ComponentType } from 'react'

/**
 * This function handles the dynamic lazy loading of the components
 * Includes:
 *  * 300 milliseconds delay
 *  * 5 load retries after 1 second
 * */
export const lazyLoadHelper = async (
  promise: Promise<{ default: ComponentType<any> }>,
  retriesLeft = 5,
  interval = 1000
) => {
  const fn = () => promise
  await new Promise((resolve) => {
    setTimeout(resolve, 300)
  })

  return new Promise<{ default: ComponentType<any> }>((resolve, reject) => {
    fn()
      .then(resolve)
      .catch((error) => {
        if (retriesLeft === 1) {
          reject(error)
          return
        }
        setTimeout(() => {
          lazyLoadHelper(promise, retriesLeft - 1, interval).then(
            resolve,
            reject
          )
        }, interval)
      })
  })
}
